<template>
    <div class="iframe-container">
      <iframe class="iframeSrc" :src="iframeSrc" width="100%" height="100%"></iframe>
    </div>
  </template>
  
  <script>
  
  export default {
    name: 'CalendarView',
    data() {
      return {
        token: '',
        username: localStorage.getItem('user') || '', // Ottieni il nome utente dal localStorage
      };
    },
    async mounted() {      
      
    },
    computed: {
      iframeSrc() {
        return `https://www-000099.theco2.net/app/000099/calendarioshooting.nsf/calendario?openForm`;
      }
    },
    methods: {
      
    }
  };
  </script>
  
  <style scoped>
  .iframe-container {
    position: absolute;
    top: 50px;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .iframeSrc {
    border: none;
    margin-top: 0px;
    margin-left: 0px;
    min-height: 900px;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  
  @media (max-width: 600px) {
    .iframeSrc {
      margin-top: 0px;
      margin-left: 0px;
      width: 100%;
      min-height: 700px;
    }
  }
  </style>
  